import type { ReactNode } from 'react';

import { Card } from '@pesto/ui/components/Card';
import { cn } from '@pesto/utils';

import type { SummaryRow } from './openAccountSummary';

const ROW_CLASS_BY_TONE: Record<NonNullable<SummaryRow['tone']>, string> = {
  warning: 'bg-warning/10 ring-warning ring-1 ring-inset',
  muted: 'text-muted-foreground font-normal',
};

interface OpenAccountSummaryRailProps {
  rows: SummaryRow[];
  children: ReactNode;
}

export const OpenAccountSummaryRail = ({ rows, children }: OpenAccountSummaryRailProps) => (
  <aside aria-labelledby="open-account-summary-title" className="lg:sticky lg:top-4">
    <Card className="bg-muted/30 flex flex-col gap-4 p-4">
      <h3 id="open-account-summary-title" className="text-muted-foreground text-xs font-medium uppercase tracking-wide">
        What this opens
      </h3>

      <dl className="flex flex-col gap-1">
        {rows.map(({ label, value, tone }) => (
          <div
            key={label}
            className={cn('-mx-2 rounded-md px-2 py-1.5 text-sm font-medium', tone && ROW_CLASS_BY_TONE[tone])}
          >
            <dt className="text-muted-foreground text-xs font-normal">{label}</dt>
            <dd className="break-words">{value}</dd>
          </div>
        ))}
      </dl>

      {children}
    </Card>
  </aside>
);
